<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Manage Product  </h6>

      <!-- <p v-for="(permission, index) in this.permissions" :key="index">
      {{ permission.permission_name }}
    </p> -->
    <!-- {{ this.permissions }} -->
      <div class="container-fluid ">
        <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">
        <div class="d-flex flex-column flex-md-row flex-wrap gap-2">

  <!-- Search input -->
  <b-input-group size="sm" class="w-100" style="max-width: 225px;">
    <b-form-input
      id="filter-input"
      class="bdr-rad"
      v-model="filter"
      @input="loadMiinventory()"
      type="search"
      placeholder="Search">
    </b-form-input>
  </b-input-group>

  <!-- From Date -->
  <b-input-group class="w-100" style="max-width: 225px;">
    <DatePicker
      v-model="FromDate"
      @input="loadMiinventory()"
      placeholder="From Date"
      ref="fromDateInput"
      class="bdr-rad"
      style="width: 100%;" />
  </b-input-group>

  <!-- To Date -->
  <b-input-group class="w-100" size="sm" style="max-width: 225px;">
    <DatePicker
      v-model="ToDate"
      @input="loadMiinventory()"
      placeholder="To Date"
      ref="fromDateInput"
      class="bdr-rad"
      style="width: 100%;" />
  </b-input-group>

  <!-- Info -->
  <div class="ms-md-2 mt-2 mt-md-0">
    <span class="custom-breadcrumb">
      <b>Showing {{ currentPage }} - {{ currentPage * perPage }} of {{ totalRows }} items.</b>
    </span>
  </div>

</div>


          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button @click="productCreate()" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">Create Product</button>
            <div>

            </div>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2 ">
          <div class="card-body mb-4">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div v-else>
              <div class="table-responsive ">
                <b-table
  responsive
  style="font-size: small;"
  class="table-hover"
  :items="all_datas"
   :fields="fields"
   :current-page="currentPage"
   head-variant="dark"
    :filter="filter"
     :filter-included-fields="filterOn"
       :sort-by.sync="sortBy"
       :sort-desc.sync="sortDesc"
       :sort-direction="sortDirection"
       show-empty
     small
   >



    <!-- <template #cell(C_name)="row">
      {{ row.value.first }} {{ row.value.last }}
    </template> -->

    <template #cell(actions)="row">

      <!-- <b-button style="background-color: rgb(71, 144, 255);"  size="sm"  class="mr-1 custom-btn">
        View
      </b-button> -->
      <!-- @mouseenter="info(row.item.idCustomer)" -->

      <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    Action
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor" @click="moreinfo(row.item.idProduct)">View</a>
    <a class="dropdown-item mouse-cursor"  @click="Update(row.item.idProduct)">Update</a>

  </div>
</div>
    </template>

    <template #cell(number)="row">
                 {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }}
                  </template>
    <template #cell(P_code1)="row">
     <a href="/" > {{ row.item.P_code }}</a>
</template>


  </b-table>

               <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
        <b-pagination
      @change="pageChanged"
      v-model="currentPage"
      pills
      :total-rows="totalRows"
      :per-page="perPage"
      size="sm">
    </b-pagination>
    </b-col>
              </div>
            </div>
          </div>
        </div>
        <br><br>
      </div>

    </div>

    <content-footer></content-footer>
  </div>
</template>


  <script>

 import axios from 'axios';
 import authService from '@/auth.service';
 import TopNavbar from './../../layout/TopNavbar.vue';
 import ContentFooter from './../../layout/ContentFooter.vue'
import DatePicker from 'vue2-datepicker';
 import 'vue2-datepicker/index.css';



  export default {
    components :{

        TopNavbar,
        ContentFooter,
        DatePicker,

    },

      mounted(){
    this.loadMiinventory()
      },

      computed: {




      },

      data() {
    return {
      currentPage: 1,
      mcustomers:[],
      all_datas:[],
    search: "",
    access_token:authService.isLoggedIn(),
      userid:authService.isUserid(),
      permissions:authService.isPermission(),
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
        FromDate: null,
        ToDate: null,
      filterOn: [],
      totalRows: '',

      perPage:15,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],

      fields: [
        { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
        { key: 'brand_name', label: 'Brand', sortable: true,  },
        { key: 'PC_description', label: 'Product Category', sortable: true  },
        { key: 'P_code1', label: 'Product Code', sortable: true  },
        { key: 'P_description', label: 'Product Description', sortable: true  },
        { key: 'P_internal_selling_price', label: 'Selling Price ($)', sortable: true  },
        { key: 'status', label: 'Status', sortable: true  },
        { key: 'P_created_date', label: 'Created Date', sortable: true ,  },


        { key: 'actions', label: 'Actions', class:'width-custom3', }
      ],

      infoModal: {
        id: 'info-modal',
        title: '',
        content: {},
      },
      isLoading: true,


    };
    },








     methods:{











    async info(idCustomer) {
  console.log(idCustomer);
  try {
    const { data} = await  axios.get('/mcustomer/view?id='+idCustomer,{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',

      }
     });
     console.log(data);
     this.infoModal.content = data.item_list
     this.$root.$emit('bv::show::modal', this.infoModal.id)


  } catch (error) {
    console.log(error.response);
  }
},
  async moreinfo(idproduct) {

this.$router.push('/mproduct/view?id='+idproduct);

},
async productCreate() {

this.$router.push('/mproduct/create');

},
async Update(id){
    this.$router.push('/mproduct/update?id='+id);
  },

  serchCustom(id) {

this.filterOn = id;
},
    // onFiltered(filteredItems) {
    //     // Trigger pagination to update the number of buttons/pages due to filtering
    //     this.totalRows = filteredItems.length
    //     console.log(totalRows);
    //     this.currentPage = 1
    //   },

      async loadMiinventory(page = this.currentPage) {
        // const storedPermissions = this.permissions;
        // const permissionsArray = JSON.parse(storedPermissions);
        // console.log(permissionsArray);
        // console.log("aaaaaaaddd");


      try {
        const { data} = await  axios.get('/mproduct/index',{

          params: {
            page: page,
            perPage: this.perPage,
            filter: this.filter,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          },
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',

          }
         });
         console.log(data);
         this.all_datas = data.all_data;
        this.totalRows = data.total_count;
        this.currentPage = data.page;
        this.isLoading = false;

      } catch (error) {
        console.log(error.response);
      }
    },

     pageChanged(newPage) {
      if (newPage !== this.previousPage) {
        console.log("Page changed to:", newPage);
        this.previousPage = newPage; // Update previous page tracker
        this.loadMiinventory(newPage);
      }
    },











  }



  };

  </script>

  <style >


  .button1{
    width: 10px !important;
  }
  .border1{
    border: none;
    background-color: #0d6efd;
  }
  .font-color1:hover{
    color: black !important;
    cursor: pointer;
  }
  .manage-boder{
      border-bottom: 2px solid #007bff;
      border-top: 2px solid #007bff;
      padding-bottom: 10px !important;
      padding-top: 10px !important;

      }
  .border-radius0{
        border-radius:0px !important ;
  }
  .font1{
        font-size: 13px !important;

      }
      .font-bold1{
        font-weight: bold;
      }
      .manage-boder{
      border-bottom: 2px solid #E9E9E3;
      border-top: 2px solid #E9E9E3;
      padding-bottom: 10px !important;
      padding-top: 10px !important;

      }
      .font1{
        font-size: 13px !important;

      }
      .font-bold1{
        font-weight: bold !important;
      }
      .colr1{
          color:#A5A5A3;

      }
      .decoration{
      text-decoration: none;
      color:#A5A5A3  ;
    }
    .width7{
      width: 250px;
    }
    .bg-mycoolor{
      background-color: #a4d2f3 !important;

    }

  .modal-footer{
    text-align: right !important;
    display: block;
  }

  .pfimg3 {
  padding-left: 10px;
}
.decoration {
  text-decoration: none;
}
.width-custom3 {
  width: 180px;
}
.date-placeholder {
  position: absolute;
  top: 5px;
  left: 12px;
  pointer-events: none;
  color: #6c757d;
}



  </style>
